import { render, staticRenderFns } from "./DiscountSelectionView.vue?vue&type=template&id=6c28ee74&"
import script from "./DiscountSelectionView.vue?vue&type=script&lang=ts&"
export * from "./DiscountSelectionView.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountSelectionView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c28ee74')) {
      api.createRecord('6c28ee74', component.options)
    } else {
      api.reload('6c28ee74', component.options)
    }
    module.hot.accept("./DiscountSelectionView.vue?vue&type=template&id=6c28ee74&", function () {
      api.rerender('6c28ee74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DiscountSelectionView.vue"
export default component.exports